document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (event) => {
    event.preventDefault();

    const target = document.querySelector(
      event.target.tagName !== 'A'
        ? event.target.parentNode.hash
        : event.target.hash,
    );

    if (target) {
      const position = target.getBoundingClientRect();
      const headerHeight = document
        .querySelector('.header')
        .getBoundingClientRect().height;
      window.scrollTo({
        top: position.top + window.scrollY - headerHeight - 20,
        behavior: 'smooth',
      });
    }
  });
});
